<template>
    <!-- Sidebar -->
    <div id="sidebar-wrapper">
        <ul class="sidebar-nav nav-pills nav-stacked" id="menu">
            <template v-for="(menu, index) in menu_data">
                <template v-if="index == 0">
                    <li :id="'company_' + menu.id" class="company">
                        <template v-if='menu.locations.length > 0'>
                            <label :title="menu.name" class="active tree-toggle nav-header" v-on:click.prevent="toggleMenu(menu)"> 
                                <!--<span class="fa-stack fa-lg pull-left"><i class="fa fa-home fa-stack-1x "></i></span> -->
                                <!-- <img src="/static/images/vvg-logo.png"> -->
                                <div v-if="menu.logo != ''" class="Sidebar_First_Letter">
                                    <img :src="menu.logo">
                                </div>
                                <div v-else class="Sidebar_First_Letter">
                                    {{getFirstChar(menu.name)}}
                                </div>
                                {{stringTrim(menu.name,18)}} <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </label>
                            <ul id="ul_home" class="nav nav-list tree" style="display: block;">
                                <template v-for="(location, index) in menu.locations">
                                    <li :id="'location' + location.id">
                                <router-link :title="menu.name" v-bind:to="{name: 'ViewContactList',params:{company:menu.id,location:location.id}}">
                                    {{stringTrim(location.name,22)}}
                                </router-link>
                                </li>
                            </template>
                        </ul>    
                    </template>
                    <template v-else>
                        <!--<router-link :title="menu.name" v-bind:to="{name: 'ViewLocationDepartments',params:{slug:menu.name}}">-->
                        <!--<span class="fa-stack fa-lg pull-left"><i class="fa fa-calendar fa-stack-1x "></i></span>-->
                        <div v-if="menu.logo != ''" class="Sidebar_First_Letter">
                            <img :src="menu.logo">
                        </div>
                        <div class="Sidebar_First_Letter" v-else>
                            {{getFirstChar(menu.name)}}
                        </div>
                        <span class="color-9cadb5">{{stringTrim(menu.name,16)}}</span> <small class="color-c3202b">(No Data)</small>
                        <!--</router-link>-->
                    </template>                    
                </li>
            </template>
            <template v-else>
                <li :id="'company_' + menu.id" class="company">
                    <template v-if='menu.locations.length > 0'>
                        <label :title="menu.name" class="tree-toggle nav-header" v-on:click.prevent="toggleMenu(menu)"> 
                            <!--<span class="fa-stack fa-lg pull-left"><i class="fa fa-home fa-stack-1x "></i></span> -->
                            <!--<img src="/static/images/vvg-logo.png" style="display:none">-->
                            <div v-if="menu.logo != ''" class="Sidebar_First_Letter">
                                <!-- {{menu.logo}} -->
                                <img :src="menu.logo">
                            </div>
                            <div v-else class="Sidebar_First_Letter">
                                {{getFirstChar(menu.name)}}
                            </div>
                            {{stringTrim(menu.name,18)}} <i class="fa fa-angle-down" aria-hidden="true"></i>
                        </label>
                        <ul id="ul_home" class="nav nav-list tree" style="display: none;">
                            <template v-for="(location, index) in menu.locations">
                                <li :id="'location' + location.id">
                            <router-link :title="menu.name" v-bind:to="{name: 'ViewContactList',params:{company:menu.id,location:location.id}}">
                                {{stringTrim(location.name,22)}}
                            </router-link>
                            </li>
                        </template>
                    </ul>    
                </template>
                <template v-else>
                    <!--<router-link :title="menu.name" v-bind:to="{name: 'ViewContactList',params:{slug:menu.id}}">-->
                    <!--<span class="fa-stack fa-lg pull-left"><i class="fa fa-calendar fa-stack-1x "></i></span>-->
                    <div v-if="menu.logo != ''" class="Sidebar_First_Letter">
                        <img :src="menu.logo">
                    </div>
                    <div class="Sidebar_First_Letter" v-else>
                        {{getFirstChar(menu.name)}}
                    </div>
                    <span class="color-9cadb5">{{stringTrim(menu.name,16)}}</span> <small class="color-c3202b">(No Data)</small>
                    <!--</router-link>-->
                </template>                    
            </li>
        </template>
    </template>
</ul>
</div>
<!-- /#wrapper -->   
</template>

<script>
    import Vue from "vue";
    import EventBus from '../../event-bus';
    import {HTTP} from '../../../http-common';
    import SessioMixin from '../../../mixins/sessionmixin';
    var self;
    export default {
        name: 'ExtensionSidebar',
        props: [''],
        components: {},
        mixins: [SessioMixin],
        data() {
            return {
                isShowLoggedinfields: true,
                userPermissions: [],
                roleId: 0,
                roleName: 0,
                system_year: '',
                openedMenu: {
                    id: 0
                },

            }
        },
        beforeMount: function () {
            self = this;
            //console.log("before mount");
        },
        mounted: function () {
            self.getMenus();
            var contact_detail_open = localStorage.getItem("contact_detail_open");
            contact_detail_open = (contact_detail_open === null || typeof (contact_detail_open) === "undefined" || contact_detail_open == '') ? false : contact_detail_open;
            if (!contact_detail_open) {
                window.localStorage.setItem("contact_detail_open", true);
            }
            EventBus.$emit("sidebarType", 'extension');
            /*$("#menu-toggle").on("click", function (e) {
             console.log('menu-toggle Extension');
             e.preventDefault();
             $(".app-sidebar-right").toggleClass("toggled");
             self.setWidthToContactContainer(550);
             });
             $("#menu-toggle-2").on("click", function (e) {
             console.log('menu-toggle-2 Extension');
             e.preventDefault();
             $(".app-sidebar-right").toggleClass("toggled-2");
             $('#menu ul').hide();
             self.setWidthToContactContainer(550);
             });*/

            $('.tree-toggle').click(function () {
                /*$('ul.tree').hide();*/
                $(this).parent().children('ul.tree').toggle(200);
                if ($(this).children().eq(1).attr('class').indexOf('fa-angle-down') != -1) {
                    $(this).children().eq(1).addClass('fa-angle-up');
                    $(this).children().eq(1).removeClass('fa-angle-down');
                } else {
                    $(this).children().eq(1).removeClass('fa-angle-up');
                    $(this).children().eq(1).addClass('fa-angle-down');
                }
            });
            setTimeout(function () {
                self.openedMenu = self.menu_data[0];
            }, 2000);
            /*console.log(this.checkLogin());*/
        },
        methods: {
            selectLocation(company, location) {
                /*console.log("Company : " + company);
                 console.log(location);*/
            },
            toggleMenu(menu) {
                /*alert(self.openedMenu.id);*/
                // return false;
                console.log(self.openedMenu);
                console.log(menu);
                if (self.openedMenu.id != menu.id) {
                    self.$router.push('/directory/extensions/' + menu.name);
                    $(".company").children('ul.tree').hide(200);
                    //$(".company").children().eq(0).children().eq(0).removeClass('fa-angle-up');
                    //$(".company").children().eq(0).children().eq(0).addClass('fa-angle-down');
                    $("#company_" + menu.id).children('ul.tree').toggle(200);
                    if ($("#company_" + menu.id).children().eq(0).children().eq(1).attr('class').indexOf('fa-angle-down') != -1) {
                        $("#company_" + menu.id).children().eq(0).children().eq(1).addClass('fa-angle-up');
                        $("#company_" + menu.id).children().eq(0).children().eq(1).removeClass('fa-angle-down');
                        $("#company_" + menu.id).children().eq(0).addClass('active');
                        $.each(self.menu_data, function (i) {
                            if (menu.id != self.menu_data[i].id) {
                                $("#company_" + self.menu_data[i].id).children().eq(0).removeClass('active');
                                $("#company_" + self.menu_data[i].id).children().eq(0).children().eq(1).removeClass('fa-angle-up');
                                $("#company_" + self.menu_data[i].id).children().eq(0).children().eq(1).addClass('fa-angle-down');
                            }
                        });
                    }/* else {
                     $("#company_"+menu.id).children().eq(0).children().eq(0).removeClass('fa-angle-up');
                     $("#company_"+menu.id).children().eq(0).children().eq(0).addClass('fa-angle-down');
                     }*/
                    self.openedMenu = menu;
                }
            },

            initMenu: function () {
                $('#menu ul').hide();
                $('#menu ul').children('.current').parent().show();
                //$('#menu ul:first').show();
                $('#menu li a').click(
                        function () {
                            var checkElement = $(this).next();
                            if ((checkElement.is('ul')) && (checkElement.is(':visible'))) {
                                return false;
                            }
                            if ((checkElement.is('ul')) && (!checkElement.is(':visible'))) {
                                $('#menu ul:visible').slideUp('normal');
                                checkElement.slideDown('normal');
                                return false;
                            }
                        }
                );
            }
        }
    }
    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.userPermissions = userPermissions;
            self.roleName = name;
            self.system_year = system_year;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/backend/partials/ExtensionSidebar.vue